export default __webpack_public_path__ + "static/media/withoutwarning.34267c4d.png";